@if (uberConnectFlag) {
  @if (isConnected === false && !showAlreadyConnected) {
    <div
      class="uber-connect-container is-connected"
      >
      <button type="button" class="connect-button" (click)="showInfo()">
        <img
          src="assets/images/Uber-Driver-App-logo.png"
          alt="Uber Logo"
          />
        <span class="hyperlink-text">Link</span
          ><span>&nbsp;&nbsp;to your Uber Account now.</span>
        </button>
        @if (isSignup) {
          <button
            class="info-button"
            type="button"
            (click)="showInfo()"
            >
            <mat-icon>info</mat-icon>
          </button>
        }
      </div>
    }
    @if (showAlreadyConnected && !isHideSuccess) {
      <div
        class="uber-connect-container uber-success"
        >
        <div class="connect-button no-pointer">
          <img src="assets/images/Uber-Driver-App-logo.png" alt="Uber Logo" />
          <span
            >Your Uber Account
            @if (connectedAccountPhone) {
              <span
                >({{ connectedAccountPhone }})</span
                >
              }
              is linked successfully.</span
              >
            </div>
          </div>
        }
        <!-- <div *ngIf="!isSignup && showAlreadyConnected"> -->
        @if (!isSignup && showAlreadyConnected && !isRemoveAccessHidden) {
          <div class="remove-access-block">
            <div class="text-center justify-between">
              <button class="btn btn-cancel" (click)="removeAccess()" id="uber-connect-remove-access-button">
                <mat-icon>close</mat-icon> Remove Access
              </button>
            </div>
            <p>
              Once you remove access, you need to re-link your account to Uber for
              connecting the JourneyTV again.
            </p>
          </div>
        }
      }
